import React, { useState } from 'react';
import WordDisplay from './WordDisplay';
import QuestionSection from './QuestionSection';
import { dariWords } from './dariWords';
import { recordSolved } from './stats';
import { reportSolve } from './push';
import TopNav from './TopNav';

function LearningPage() {
  const initialRandomIndex = Math.floor(Math.random() * dariWords.length);
  const initialWord = dariWords[initialRandomIndex].dari;

  const [currentWord, setCurrentWord] = useState(initialWord);
  const [currentLetterIndex, setCurrentLetterIndex] = useState(0);

  const handleCorrectAnswer = () => {
    if (currentLetterIndex === currentWord.length) {
      // Whole word solved (all letters + meaning) — count it.
      recordSolved();
      reportSolve();
      const randomIndex = Math.floor(Math.random() * dariWords.length);
      const newWord = dariWords[randomIndex].dari;
      setCurrentWord(newWord);
      setCurrentLetterIndex(0);
    } else {
      setCurrentLetterIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <div className='screen'>
      <TopNav active='words' />

      <main className='quiz-card'>
        <WordDisplay currentWord={currentWord} currentLetterIndex={currentLetterIndex} />
        <QuestionSection
          currentWord={currentWord}
          currentLetterIndex={currentLetterIndex}
          onCorrectAnswer={handleCorrectAnswer}
        />
      </main>
    </div>
  );
}

export default LearningPage;
